import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import type { User } from '@jooxter/api';

/**
 * Attaches the signed-in user to Sentry events so issues show how many users are affected
 * (they all read "0 users" today) and can be grouped per corporation.
 *
 * Only identifiers are sent — no email or name — to keep PII out of Sentry.
 * Safe to call when Sentry is not initialized: setUser/setTag are then no-ops.
 */
export const useSentryUser = (user?: User) => {
  useEffect(() => {
    if (!user?.id) {
      Sentry.setUser(null);
      Sentry.setTag('corporation', undefined);
      return;
    }

    Sentry.setUser({ id: String(user.id) });
    Sentry.setTag('corporation', user.corporation?.id !== undefined ? String(user.corporation.id) : undefined);
  }, [user?.id, user?.corporation?.id]);
};
